import LocationsApiService from '@services/locations.api.service';
import JWTService from '@services/jwt.service';

import { MutationTypes, ActionTypes } from '@store/modules/locations.types';

export default {
  namespaced: true,
  state: {
    locations: JWTService.getLocations(),
    suffix: JWTService.getLocationSuffix(),
  },
  mutations: {
    [MutationTypes.SET_LOCATIONS](state, payload) {
      state.locations = payload;
      JWTService.setLocations(JSON.stringify(payload));
    },
    [MutationTypes.SET_SUFFIX](state, payload) {
      state.suffix = payload;
      JWTService.setLocationSuffix(payload);
    },
  },
  actions: {
    async [ActionTypes.GET_LOCATIONS]({ commit, state: { suffix: currentSuffix } }, { suffix }) {
      const data = await LocationsApiService.getLocations();
      const currentLocation = suffix || currentSuffix;
      const [firstLocationData = {}] = data;
      const filteredLocationData = data
        .find((location) => location.suffix === currentLocation) || {};

      commit(MutationTypes.SET_LOCATIONS, data);
      commit(MutationTypes.SET_SUFFIX, filteredLocationData.suffix || firstLocationData.suffix || '');
    },
  },
};
